const state = () => ({
  dialogVisible: false,
  activeDialog: '',
  dialogTitle: '',
  userDialog: false,
  isEditable: false,
  userIdForAccount: null,
  managerFor: '',
  isOpenUL: false,
  baActivePlatform: null,
  transactionToDelete: null,
});

const getters = {};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
};

const actions = {
  closeDialog({ commit }, action) {
    commit('setData', { label: 'dialogVisible', data: false });
    commit('setData', { label: 'activeDialog', data: '' });
    if (action && typeof action === 'function') {
      action();
    }
  },
  setData({ commit }, data) {
    commit('setData', { label: data.label, data: data.data });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
